module.exports = __webpack_public_path__ + "media/meditation-full.234078c6.mp3";